import { ImageElement } from '../../model/types';

export interface CropRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

/**
 * Kadr dla trybu "wypełnij": wycinamy z oryginału największy prostokąt
 * o proporcjach ramki, wyśrodkowany. Bez tego Konva rozciągnęłaby zdjęcie.
 */
export const coverCrop = (
  image: HTMLImageElement,
  width: number,
  height: number,
  /** Punkt ostrości 0-1; 0.5 to środek, czyli zachowanie sprzed dodania kadrowania. */
  focusX = 0.5,
  focusY = 0.5,
): CropRect => {
  const boxRatio = width / height;
  const imageRatio = image.naturalWidth / image.naturalHeight;
  const clamp = (value: number): number => Math.min(Math.max(value, 0), 1);

  if (imageRatio > boxRatio) {
    const cropWidth = image.naturalHeight * boxRatio;
    const maxX = image.naturalWidth - cropWidth;
    return { x: maxX * clamp(focusX), y: 0, width: cropWidth, height: image.naturalHeight };
  }

  const cropHeight = image.naturalWidth / boxRatio;
  const maxY = image.naturalHeight - cropHeight;
  return { x: 0, y: maxY * clamp(focusY), width: image.naturalWidth, height: cropHeight };
};

/** Rozmiar i przesunięcie zdjęcia w trybie "zmieść w całości". */
export const containBox = (image: HTMLImageElement, width: number, height: number): CropRect => {
  const scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
  const drawWidth = image.naturalWidth * scale;
  const drawHeight = image.naturalHeight * scale;
  return {
    x: (width - drawWidth) / 2,
    y: (height - drawHeight) / 2,
    width: drawWidth,
    height: drawHeight,
  };
};

/** Promień zaokrąglenia narożników z uwzględnieniem maski koła. */
export const imageCornerRadius = (element: ImageElement): number => (
  element.circle ? Math.min(element.width, element.height) / 2 : element.radius
);

export const trianglePoints = (width: number, height: number): number[] => [
  width / 2, 0,
  width, height,
  0, height,
];
